import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type Tone = 'default' | 'debt' | 'income' | 'muted';

const toneClasses: Record<Tone, string> = {
  default: 'bg-primary/10 text-primary',
  debt: 'bg-debt/10 text-debt',
  income: 'bg-income/10 text-income',
  muted: 'bg-muted text-muted-foreground',
};

export function Badge({ tone = 'default', className, ...props }: HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      className={cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', toneClasses[tone], className)}
      {...props}
    />
  );
}
